import { ActionTile } from "@fullscript/aviary-web";
import type { IconDefinition } from "@fullscript/fontawesome-common-types";

import * as styles from "../RegionSelectorPage.styles";

interface Props {
  region: string;
  label: string;
  blurbText: string;
  icon: IconDefinition;
}

const RegionTile = ({ label, blurbText, icon }: Props) => {
  return (
    <ActionTile
      intention="accentGreen"
      icon={{ icon }}
      label={label}
      content={blurbText}
      customCss={styles.tile}
    />
  );
};

export { RegionTile };
